/* Mom's Tallow - Future Lab interactions */
(function () {
  var root = document.documentElement;
  root.classList.remove('no-js');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* frosted header on scroll */
  var ticking = false;
  function onScroll() {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () { root.classList.toggle('mt-scrolled', window.scrollY > 8); ticking = false; });
  }
  window.addEventListener('scroll', onScroll, { passive: true }); onScroll();

  /* reveal on scroll */
  function reveal(scope) {
    var els = (scope || document).querySelectorAll('.mt-reveal:not(.is-in)');
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }
  window.mtReveal = reveal;
  if (document.readyState !== 'loading') reveal(); else document.addEventListener('DOMContentLoaded', function () { reveal(); });
  document.addEventListener('shopify:section:load', function (e) { reveal(e.target); });

  /* add to cart helper (uses Shopify standard actions so Horizon's drawer + bubble update) */
  window.mtAddToCart = function (variantId, qty, sellingPlan) {
    qty = Math.max(1, parseInt(qty, 10) || 1);
    var A = window.Shopify && window.Shopify.actions;
    if (A && A.updateCart) {
      var line = { merchandiseId: String(variantId), quantity: qty };
      if (sellingPlan) line.sellingPlanId = String(sellingPlan);
      return A.updateCart({ lines: [line] }, { event: { context: 'product' } }).then(function (res) {
        if (res && res.userErrors && res.userErrors.length) throw new Error(res.userErrors[0].message);
        try { if (A.openCart) A.openCart(); } catch (e) {}
        return res;
      });
    }
    var body = { items: [{ id: Number(variantId), quantity: qty }] };
    if (sellingPlan) body.items[0].selling_plan = Number(sellingPlan);
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || 'Could not add'); window.location.href = '/cart'; return j; }); });
  };

  /* quick-add buttons on custom cards */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-mt-add]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    if (b.classList.contains('is-busy')) return;
    b.classList.add('is-busy');
    var orig = b.innerHTML;
    window.mtAddToCart(b.getAttribute('data-mt-add'), 1).then(function () {
      b.classList.remove('is-busy');
      if (b.dataset.mtLabel) { b.textContent = 'Added'; setTimeout(function () { b.innerHTML = orig; }, 1600); }
    }).catch(function (err) {
      b.classList.remove('is-busy');
      if (b.dataset.mtUrl) window.location.href = b.dataset.mtUrl;
      else alertless(err);
    });
  });
  function alertless(err) { if (window.console) console.warn('[mt] add to cart', err); }
})();